export const navItems = [
  { id: "featured", label: "本期主推" },
  { id: "rail", label: "栏目分区" },
  { id: "timeline", label: "时间线还原" },
  { id: "compare", label: "图文对比" },
  { id: "ranking", label: "内幕榜单" },
];

export const tickerItems = [
  "本期上新：一段聊天记录如何被还原成 72 小时时间线",
  "长图速览：同一条声明，四个平台的发布时间差说明什么",
  "对比拆解：旧访谈与现说法之间的措辞漂移",
  "幕后关联：把散落的公开动态拼回一条因果链",
  "编辑手记：逐层拆解比结论更重要",
];

export const heroMeta = [
  { value: "1,280", label: "长图专题" },
  { value: "96", label: "组时间线" },
  { value: "3.2万", label: "图文对比" },
];

export const heroCover = {
  image:
    "https://readdy.ai/api/search-image?query=Abstract%20editorial%20magazine%20cover%20still%20life%2C%20neatly%20stacked%20warm%20cream%20paper%20sheets%20with%20blank%20folded%20posters%2C%20a%20closed%20magnifying%20glass%20resting%20on%20top%2C%20soft%20natural%20side%20light%2C%20muted%20vermillion%20and%20amber%20color%20accents%2C%20minimal%20warm%20background%2C%20subtle%20film%20grain%2C%20high%20detail%2C%20no%20text%2C%20no%20logos%2C%20no%20people%2C%20elegant%20art%20direction%2C%20calm%20analytical%20mood&width=900&height=1120&seq=hl-hero-cover&orientation=portrait",
  issue: "VOL. 128",
  badge: "封面长图",
  cornerLabel: "逐层拆解",
};

export const featuredMain = {
  tag: "深扒长图",
  title: "一段聊天记录，如何被还原成七十二小时时间线",
  excerpt:
    "把零散的截图、被删除的动态和公开行程按分钟对齐，矛盾点自然浮出。本期长图用四层时间轴，把事件的起点、转折与收尾放在同一张图上对比阅读。",
  image:
    "https://readdy.ai/api/search-image?query=Editorial%20collage%20of%20long%20vertical%20scroll%20screenshots%20rendered%20as%20abstract%20blank%20panels%20connected%20by%20a%20thin%20thread%2C%20warm%20cream%20and%20muted%20rust%20tones%2C%20soft%20studio%20light%2C%20minimal%20geometric%20background%2C%20subtle%20grain%2C%20no%20readable%20text%2C%20no%20logos%2C%20no%20people%2C%20refined%20magazine%20illustration%20feel%2C%20investigative%20analytical%20atmosphere%2C%20high%20detail%2C%20elegant%20negative%20space&width=1200&height=760&seq=hl-feature-main&orientation=landscape",
  meta: ["四层时间轴", "长图 1680px", "图 42 张", "阅读 11 分钟"],
};

export const featuredCards = [
  {
    tag: "图文对比",
    title: "同一条声明，四个平台的发布时间差说明了什么",
    excerpt: "把发布渠道的先后顺序排开，传播路径比措辞更早暴露意图。",
    date: "09.10",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20still%20life%20of%20an%20open%20notebook%20with%20blank%20pages%20and%20a%20folded%20pair%20of%20eyeglasses%20on%20a%20warm%20cream%20surface%2C%20muted%20rust%20and%20amber%20accents%2C%20soft%20daylight%20from%20the%20side%2C%20minimal%20background%2C%20subtle%20film%20grain%2C%20no%20text%2C%20no%20logos%2C%20no%20people%2C%20calm%20editorial%20magazine%20photography%20style%2C%20investigative%20mood%2C%20high%20detail&width=800&height=600&seq=hl-feature-2&orientation=landscape",
  },
  {
    tag: "时间线还原",
    title: "从三条公开动态，看一场合作关系的悄然转向",
    excerpt: "互动频率、措辞温度与同框次数，三条线交叉后指向同一个拐点。",
    date: "09.08",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20scene%20of%20blank%20chat%20bubble%20shapes%20arranged%20in%20a%20neat%20grid%20on%20warm%20beige%20paper%2C%20muted%20rust%20accent%20block%2C%20soft%20even%20light%2C%20minimal%20flat%20background%2C%20subtle%20grain%2C%20no%20readable%20text%2C%20no%20logos%2C%20no%20people%2C%20refined%20magazine%20illustration%2C%20analytical%20storytelling%20mood%2C%20high%20detail&width=800&height=600&seq=hl-feature-3&orientation=landscape",
  },
  {
    tag: "内幕解析",
    title: "旧访谈与现说法对照：措辞变化里藏着哪些信号",
    excerpt: "同一件事的两次叙述，删掉的和补上的词，往往比语气更诚实。",
    date: "09.05",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20top%20down%20flat%20lay%20of%20a%20blank%20printed%20timeline%20strip%20curled%20across%20warm%20cream%20paper%2C%20small%20amber%20paper%20tags%2C%20soft%20natural%20light%2C%20minimal%20warm%20background%2C%20subtle%20film%20grain%2C%20no%20text%2C%20no%20logos%2C%20no%20people%2C%20refined%20editorial%20magazine%20still%20life%2C%20methodical%20investigative%20atmosphere%2C%20high%20detail&width=800&height=600&seq=hl-feature-4&orientation=landscape",
  },
];

export const sectionRail = [
  {
    id: "rail-longpic",
    icon: "ri-stack-line",
    title: "深扒长图",
    desc: "把复杂事件压成一张可以从头读到尾的长图，先看全貌再看细节。",
    count: "1,280 期专题",
    accent: "primary",
  },
  {
    id: "rail-timeline",
    icon: "ri-history-line",
    title: "时间线还原",
    desc: "按分钟对齐公开动作与截图时间戳，让先后顺序自己说话。",
    count: "96 组时间轴",
    accent: "accent",
  },
  {
    id: "rail-compare",
    icon: "ri-layout-2-line",
    title: "图文对比",
    desc: "把聊天记录与公开动态并排放，差异处就是最该细读的地方。",
    count: "3.2万 组对照",
    accent: "secondary",
  },
  {
    id: "rail-inside",
    icon: "ri-search-eye-line",
    title: "内幕解析",
    desc: "拆开来龙去脉、幕后关联与关键人，逐层还原事件的完整骨架。",
    count: "每周 12 篇深度",
    accent: "primary",
  },
];

export const timelineEvents = [
  {
    time: "T-72h",
    title: "第一条动态上线",
    desc: "配图含蓄、措辞克制，评论区仍以正向互动为主。",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20representation%20of%20anonymous%20chat%20records%20as%20blank%20rounded%20message%20bubbles%20floating%20on%20warm%20beige%20paper%2C%20muted%20rust%20and%20charcoal%20tones%2C%20soft%20calm%20light%2C%20minimal%20background%2C%20subtle%20grain%2C%20no%20readable%20text%2C%20no%20logos%2C%20no%20people%2C%20refined%20magazine%20illustration%2C%20quiet%20analytical%20mood%2C%20high%20detail&width=800&height=800&seq=hl-compare-a&orientation=squarish",
  },
  {
    time: "T-40h",
    title: "一段旧截图被翻出",
    desc: "时间戳与当下说法出现十二小时的缺口，第一处矛盾出现。",
    image: "",
  },
  {
    time: "T-12h",
    title: "关键动态被删除",
    desc: "删除动作本身成为线索，缓存快照与转载记录补上了空白。",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20representation%20of%20public%20posts%20as%20blank%20stacked%20social%20cards%20on%20a%20warm%20cream%20desk%2C%20muted%20amber%20and%20charcoal%20tones%2C%20soft%20calm%20daylight%2C%20minimal%20background%2C%20subtle%20film%20grain%2C%20no%20readable%20text%2C%20no%20logos%2C%20no%20people%2C%20refined%20magazine%20illustration%2C%20quiet%20analytical%20mood%2C%20high%20detail&width=800&height=800&seq=hl-compare-b&orientation=squarish",
  },
  {
    time: "T-0",
    title: "完整时间线成图",
    desc: "四层轴对齐后，前因后果与幕后关联落在同一条线上。",
    image: "",
  },
];

export const compareItems = [
  {
    label: "聊天记录",
    caption: "私域对话的措辞温度，比公开表达更早出现转向。",
    note: "对照点 01",
  },
  {
    label: "公开动态",
    caption: "公开发布的时间差与配图选择，暴露传播的先后次序。",
    note: "对照点 02",
  },
  {
    label: "声明文本",
    caption: "被删掉与被补上的词，往往对应着最想回避的那部分。",
    note: "对照点 03",
  },
];

export const rankingItems = [
  { rank: 1, title: "被删的三张图，与仍然留下的评论区", heat: 96, tag: "内幕解析" },
  { rank: 2, title: "两份海报的版式差异里，藏着同一条暗线", heat: 88, tag: "图文对比" },
  { rank: 3, title: "从互动频率骤降，倒推关系结束的时间点", heat: 81, tag: "时间线还原" },
  { rank: 4, title: "同一段采访，三年后为何换了说法", heat: 74, tag: "深扒长图" },
  { rank: 5, title: "一张同框照片，如何牵出完整的人物关系图", heat: 66, tag: "图文对比" },
];

export const statsItems = [
  { value: "1,280", unit: "期", label: "已发布深扒长图" },
  { value: "168", unit: "万", label: "长图累计阅读" },
  { value: "96", unit: "组", label: "还原完成时间线" },
  { value: "11", unit: "分钟", label: "单篇平均阅读时长" },
];

export const footerColumns = [
  {
    title: "栏目",
    links: ["深扒长图", "时间线还原", "图文对比", "内幕解析"],
  },
  {
    title: "关于",
    links: ["编辑准则", "长图制作说明", "纠错与反馈", "团队介绍"],
  },
  {
    title: "服务",
    links: ["客户端下载", "订阅更新", "版权说明", "联系我们"],
  },
];